// Steps to upgrade
// Algolia.urls are used to proxy pass the request for enterpries users.
// So use Algolia.urls (app/views/static/habitats/_header.html.erb) in this file

!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define(t)
    : ((e = e || self).algoliasearch = t());
})(this, function () {
  'use strict';

  function e(e, t, r) {
    return (
      t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e
    );
  }
  function t(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t &&
        (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        r.push.apply(r, n);
    }
    return r;
  }
  function r(r) {
    for (var n = 1; n < arguments.length; n++) {
      var o = null != arguments[n] ? arguments[n] : {};
      n % 2
        ? t(Object(o), !0).forEach(function (t) {
            e(r, t, o[t]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o))
        : t(Object(o)).forEach(function (e) {
            Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
          });
    }
    return r;
  }
  function n(e, t) {
    return (
      (function (e) {
        if (Array.isArray(e)) return e;
      })(e) ||
      (function (e, t) {
        if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
          var r = [],
            n = !0,
            o = !1,
            a = void 0;
          try {
            for (
              var u, i = e[Symbol.iterator]();
              !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t);
              n = !0
            );
          } catch (e) {
            (o = !0), (a = e);
          } finally {
            try {
              n || null == i.return || i.return();
            } finally {
              if (o) throw a;
            }
          }
          return r;
        }
      })(e, t) ||
      (function () {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      })()
    );
  }
  function o(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) r[t] = e[t];
          return r;
        }
      })(e) ||
      (function (e) {
        if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
          return Array.from(e);
      })(e) ||
      (function () {
        throw new TypeError('Invalid attempt to spread non-iterable instance');
      })()
    );
  }
  function a(e) {
    var t = e.localStorage || window.localStorage,
      r = 'algoliasearch-client-js-'.concat(e.key),
      o = function () {
        return JSON.parse(t.getItem(r) || '{}');
      };
    return {
      get: function (e, t) {
        var r =
          arguments.length > 2 && void 0 !== arguments[2]
            ? arguments[2]
            : {
                miss: function () {
                  return Promise.resolve();
                },
              };
        return Promise.resolve()
          .then(function () {
            var r = JSON.stringify(e),
              n = o()[r];
            return Promise.all([n || t(), void 0 !== n]);
          })
          .then(function (e) {
            var t = n(e, 2),
              o = t[0],
              a = t[1];
            return Promise.all([o, a || r.miss(o)]);
          })
          .then(function (e) {
            return n(e, 1)[0];
          });
      },
      set: function (e, n) {
        return Promise.resolve().then(function () {
          var a = o();
          return (a[JSON.stringify(e)] = n), t.setItem(r, JSON.stringify(a)), n;
        });
      },
      delete: function (e) {
        return Promise.resolve().then(function () {
          var n = o();
          delete n[JSON.stringify(e)], t.setItem(r, JSON.stringify(n));
        });
      },
      clear: function () {
        return Promise.resolve().then(function () {
          t.removeItem(r);
        });
      },
    };
  }
  function u(e) {
    var t = o(e.caches),
      r = t.shift();
    return void 0 === r
      ? {
          get: function (e, t) {
            var r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {
                    miss: function () {
                      return Promise.resolve();
                    },
                  };
            return t()
              .then(function (e) {
                return Promise.all([e, r.miss(e)]);
              })
              .then(function (e) {
                return n(e, 1)[0];
              });
          },
          set: function (e, t) {
            return Promise.resolve(t);
          },
          delete: function (e) {
            return Promise.resolve();
          },
          clear: function () {
            return Promise.resolve();
          },
        }
      : {
          get: function (e, n) {
            var o =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {
                    miss: function () {
                      return Promise.resolve();
                    },
                  };
            return r.get(e, n, o).catch(function () {
              return u({ caches: t }).get(e, n, o);
            });
          },
          set: function (e, n) {
            return r.set(e, n).catch(function () {
              return u({ caches: t }).set(e, n);
            });
          },
          delete: function (e) {
            return r.delete(e).catch(function () {
              return u({ caches: t }).delete(e);
            });
          },
          clear: function () {
            return r.clear().catch(function () {
              return u({ caches: t }).clear();
            });
          },
        };
  }
  function i() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { serializable: !0 },
      t = {};
    return {
      get: function (r, n) {
        var o =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : {
                  miss: function () {
                    return Promise.resolve();
                  },
                },
          a = JSON.stringify(r);
        if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
        var u = n(),
          i =
            (o && o.miss) ||
            function () {
              return Promise.resolve();
            };
        return u
          .then(function (e) {
            return i(e);
          })
          .then(function () {
            return u;
          });
      },
      set: function (r, n) {
        return (t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n), Promise.resolve(n);
      },
      delete: function (e) {
        return delete t[JSON.stringify(e)], Promise.resolve();
      },
      clear: function () {
        return (t = {}), Promise.resolve();
      },
    };
  }
  function s(e) {
    for (var t = e.length - 1; t > 0; t--) {
      var r = Math.floor(Math.random() * (t + 1)),
        n = e[t];
      (e[t] = e[r]), (e[r] = n);
    }
    return e;
  }
  function c(e, t) {
    return (
      Object.keys(void 0 !== t ? t : {}).forEach(function (r) {
        e[r] = t[r](e);
      }),
      e
    );
  }
  function l(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
    var o = 0;
    return e.replace(/%s/g, function () {
      return encodeURIComponent(r[o++]);
    });
  }
  var f = { WithinQueryParameters: 0, WithinHeaders: 1 };
  function h(e, t) {
    var r = e || {},
      n = r.data || {};
    return (
      Object.keys(r).forEach(function (e) {
        -1 === ['timeout', 'headers', 'queryParameters', 'data', 'cacheable'].indexOf(e) && (n[e] = r[e]);
      }),
      {
        data: Object.entries(n).length > 0 ? n : void 0,
        timeout: r.timeout || t,
        headers: r.headers || {},
        queryParameters: r.queryParameters || {},
        cacheable: r.cacheable,
      }
    );
  }
  var d = { Read: 1, Write: 2, Any: 3 },
    m = 1,
    p = 2,
    v = 3;
  function g(e) {
    return r({}, e, {
      status: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : m,
      lastUpdate: Date.now(),
    });
  }
  function y(e) {
    return { protocol: e.protocol || 'https', url: e.url, accept: e.accept || d.Any };
  }
  var b = 'GET',
    O = 'POST';
  function P(e, t, n, a) {
    var u = [],
      i = (function (e, t) {
        if (e.method !== b && (void 0 !== e.data || void 0 !== t.data)) {
          var n = Array.isArray(e.data) ? e.data : r({}, e.data, {}, t.data);
          return JSON.stringify(n);
        }
      })(n, a),
      s = (function (e, t) {
        var n = r({}, e.headers, {}, t.headers),
          o = {};
        return (
          Object.keys(n).forEach(function (e) {
            var t = n[e];
            o[e.toLowerCase()] = t;
          }),
          o
        );
      })(e, a),
      c = n.method,
      l = n.method !== b ? {} : r({}, n.data, {}, a.data),
      f = r({ 'x-algolia-agent': e.userAgent.value }, e.queryParameters, {}, l, {}, a.queryParameters),
      h = 0,
      d = function t(r, o) {
        var l = r.pop();
        if (void 0 === l)
          throw {
            name: 'RetryError',
            message:
              'Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.',
            transporterStackTrace: w(u),
          };
        var d = {
            data: i,
            headers: s,
            method: c,
            url: j(l, n.path, f),
            connectTimeout: o(h, e.timeouts.connect),
            responseTimeout: o(h, a.timeout),
          },
          m = function (e) {
            var t = { request: d, response: e, host: l, triesLeft: r.length };
            return u.push(t), t;
          },
          y = {
            onSucess: function (e) {
              return (function (e) {
                try {
                  return JSON.parse(e.content);
                } catch (t) {
                  throw (function (e, t) {
                    return { name: 'DeserializationError', message: e, response: t };
                  })(t.message, e);
                }
              })(e);
            },
            onRetry: function (n) {
              var a = m(n);
              return (
                n.isTimedOut && h++,
                Promise.all([
                  e.logger.info('Retryable failure', A(a)),
                  e.hostsCache.set(l, g(l, n.isTimedOut ? v : p)),
                ]).then(function () {
                  return t(r, o);
                })
              );
            },
            onFail: function (e) {
              throw (
                (m(e),
                (function (e, t) {
                  var r = e.content,
                    n = e.status,
                    o = r;
                  try {
                    o = JSON.parse(r).message;
                  } catch (e) {}
                  return (function (e, t, r) {
                    return { name: 'ApiError', message: o, status: n, transporterStackTrace: r };
                  })(0, 0, t);
                })(e, w(u)))
              );
            },
          };
        return e.requester.send(d).then(function (e) {
          return (function (e, t) {
            return (function (e) {
              var t = e.status;
              return (
                e.isTimedOut ||
                (function (e) {
                  var t = e.isTimedOut,
                    r = e.status;
                  return !t && 0 == ~~r;
                })(e) ||
                (2 != ~~(t / 100) && 4 != ~~(t / 100))
              );
            })(e)
              ? t.onRetry(e)
              : 2 == ~~(e.status / 100)
              ? t.onSucess(e)
              : t.onFail(e);
          })(e, y);
        });
      };
    return (function (e, t) {
      return Promise.all(
        t.map(function (t) {
          return e.get(t, function () {
            return Promise.resolve(g(t));
          });
        })
      ).then(function (e) {
        var r = e.filter(function (e) {
            return (function (e) {
              return e.status === m || Date.now() - e.lastUpdate > 12e4;
            })(e);
          }),
          n = e.filter(function (e) {
            return (function (e) {
              return e.status === v && Date.now() - e.lastUpdate <= 12e4;
            })(e);
          }),
          a = [].concat(o(r), o(n));
        return {
          getTimeout: function (e, t) {
            return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
          },
          statelessHosts:
            a.length > 0
              ? a.map(function (e) {
                  return y(e);
                })
              : t,
        };
      });
    })(e.hostsCache, t).then(function (e) {
      return d(o(e.statelessHosts).reverse(), e.getTimeout);
    });
  }
  function q(e) {
    var t = {
      value: 'Algolia for JavaScript ('.concat(e, ')'),
      add: function (e) {
        var r = '; '.concat(e.segment).concat(void 0 !== e.version ? ' ('.concat(e.version, ')') : '');
        return -1 === t.value.indexOf(r) && (t.value = ''.concat(t.value).concat(r)), t;
      },
    };
    return t;
  }
  function j(e, t, r) {
    var n = S(r),
      o = ''
        .concat(e.protocol, '://')
        .concat(e.url, '/')
        .concat('/' === t.charAt(0) ? t.substr(1) : t);
    return n.length && (o += '?'.concat(n)), o;
  }
  function S(e) {
    return Object.keys(e)
      .map(function (t) {
        return l(
          '%s=%s',
          t,
          ((r = e[t]),
          '[object Object]' === Object.prototype.toString.call(r) ||
          '[object Array]' === Object.prototype.toString.call(r)
            ? JSON.stringify(e[t])
            : e[t])
        );
        var r;
      })
      .join('&');
  }
  function w(e) {
    return e.map(function (e) {
      return A(e);
    });
  }
  function A(e) {
    var t = e.request.headers['x-algolia-api-key'] ? { 'x-algolia-api-key': '*****' } : {};
    return r({}, e, { request: r({}, e.request, { headers: r({}, e.request.headers, {}, t) }) });
  }
  var T = function (e) {
      var t = e.appId,
        o = (function (e, t, r) {
          var n = { 'x-algolia-api-key': r, 'x-algolia-application-id': t };
          return {
            headers: function () {
              return e === f.WithinHeaders ? n : {};
            },
            queryParameters: function () {
              return e === f.WithinQueryParameters ? n : {};
            },
          };
        })(void 0 !== e.authMode ? e.authMode : f.WithinHeaders, t, e.apiKey),
        a = (function (e) {
          var t = e.hostsCache,
            r = e.logger,
            o = e.requester,
            a = e.requestsCache,
            u = e.responsesCache,
            i = e.timeouts,
            s = e.userAgent,
            c = e.hosts,
            l = e.queryParameters,
            f = {
              hostsCache: t,
              logger: r,
              requester: o,
              requestsCache: a,
              responsesCache: u,
              timeouts: i,
              userAgent: s,
              headers: e.headers,
              queryParameters: l,
              hosts: c.map(function (e) {
                return y(e);
              }),
              read: function (e, t) {
                var r = h(t, f.timeouts.read),
                  o = function () {
                    return P(
                      f,
                      f.hosts.filter(function (e) {
                        return 0 != (e.accept & d.Read);
                      }),
                      e,
                      r
                    );
                  };
                if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return o();
                var a = {
                  request: e,
                  mappedRequestOptions: r,
                  transporter: { queryParameters: f.queryParameters, headers: f.headers },
                };
                return f.responsesCache.get(
                  a,
                  function () {
                    return f.requestsCache.get(a, function () {
                      return f.requestsCache
                        .set(a, o())
                        .then(
                          function (e) {
                            return Promise.all([f.requestsCache.delete(a), e]);
                          },
                          function (e) {
                            return Promise.all([f.requestsCache.delete(a), Promise.reject(e)]);
                          }
                        )
                        .then(function (e) {
                          var t = n(e, 2);
                          return t[0], t[1];
                        });
                    });
                  },
                  {
                    miss: function (e) {
                      return f.responsesCache.set(a, e);
                    },
                  }
                );
              },
              write: function (e, t) {
                return P(
                  f,
                  f.hosts.filter(function (e) {
                    return 0 != (e.accept & d.Write);
                  }),
                  e,
                  h(t, f.timeouts.write)
                );
              },
            };
          return f;
        })(
          r(
            {
              hosts: [
                { url: 'YNHF55KPOX-dsn.algolia.net', accept: d.Read },
                { url: 'YNHF55KPOX.algolia.net', accept: d.Write },
              ].concat(
                s([
                  { url: 'YNHF55KPOX-1.algolianet.com' },
                  { url: 'YNHF55KPOX-2.algolianet.com' },
                  { url: 'YNHF55KPOX-3.algolianet.com' },
                ])
              ),
            },
            e,
            {
              headers: r({}, o.headers(), {}, { 'content-type': 'application/x-www-form-urlencoded' }, {}, e.headers),
              queryParameters: r({}, o.queryParameters(), {}, e.queryParameters),
            }
          )
        );
      return c(
        {
          transporter: a,
          appId: t,
          addAlgoliaAgent: function (e, t) {
            a.userAgent.add({ segment: e, version: t });
          },
          clearCache: function () {
            return Promise.all([a.requestsCache.clear(), a.responsesCache.clear()]).then(function () {});
          },
        },
        e.methods
      );
    },
    x = function (e) {
      return function (t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return c({ transporter: e.transporter, appId: e.appId, indexName: t }, r.methods);
      };
    },
    C = function (e) {
      return function (t, n) {
        var o = t.map(function (e) {
          return r({}, e, { params: S(e.params || {}) });
        });
        return e.transporter.read({ method: O, path: '1/indexes/*/queries', data: { requests: o }, cacheable: !0 }, n);
      };
    },
    N = function (e) {
      return function (t, n) {
        return Promise.all(
          t.map(function (t) {
            var o = t.params,
              a = o.facetName,
              u = o.facetQuery,
              i = (function (e, t) {
                if (null == e) return {};
                var r,
                  n,
                  o = (function (e, t) {
                    if (null == e) return {};
                    var r,
                      n,
                      o = {},
                      a = Object.keys(e);
                    for (n = 0; n < a.length; n++) (r = a[n]), t.indexOf(r) >= 0 || (o[r] = e[r]);
                    return o;
                  })(e, t);
                if (Object.getOwnPropertySymbols) {
                  var a = Object.getOwnPropertySymbols(e);
                  for (n = 0; n < a.length; n++)
                    (r = a[n]),
                      t.indexOf(r) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]));
                }
                return o;
              })(o, ['facetName', 'facetQuery']);
            return x(e)(t.indexName, { methods: { searchForFacetValues: J } }).searchForFacetValues(
              a,
              u,
              r({}, n, {}, i)
            );
          })
        );
      };
    },
    k = function (e) {
      return function (t, r) {
        return e.transporter.read(
          { method: O, path: l('1/indexes/%s/query', e.indexName), data: { query: t }, cacheable: !0 },
          r
        );
      };
    },
    J = function (e) {
      return function (t, r, n) {
        return e.transporter.read(
          {
            method: O,
            path: l('1/indexes/%s/facets/%s/query', e.indexName, t),
            data: { facetQuery: r },
            cacheable: !0,
          },
          n
        );
      };
    },
    E = 1,
    I = 2,
    F = 3;
  function R(e, t, n) {
    var o,
      s = {
        appId: e,
        apiKey: t,
        timeouts: { connect: 1, read: 2, write: 30 },
        requester: {
          send: function (e) {
            return new Promise(function (t) {
              var r = new XMLHttpRequest();
              r.open(e.method, e.url, !0),
                Object.keys(e.headers).forEach(function (t) {
                  return r.setRequestHeader(t, e.headers[t]);
                });
              var n,
                o = function (e, n) {
                  return setTimeout(function () {
                    r.abort(), t({ status: 0, content: n, isTimedOut: !0 });
                  }, 1e3 * e);
                },
                a = o(e.connectTimeout, 'Connection timeout');
              (r.onreadystatechange = function () {
                r.readyState > r.OPENED &&
                  void 0 === n &&
                  (clearTimeout(a), (n = o(e.responseTimeout, 'Socket timeout')));
              }),
                (r.onerror = function () {
                  0 === r.status &&
                    (clearTimeout(a),
                    clearTimeout(n),
                    t({ content: r.responseText || 'Network request failed', status: r.status, isTimedOut: !1 }));
                }),
                (r.onload = function () {
                  clearTimeout(a), clearTimeout(n), t({ content: r.responseText, status: r.status, isTimedOut: !1 });
                }),
                r.send(e.data);
            });
          },
        },
        logger:
          ((o = F),
          {
            debug: function (e, t) {
              return E >= o && console.debug(e, t), Promise.resolve();
            },
            info: function (e, t) {
              return I >= o && console.info(e, t), Promise.resolve();
            },
            error: function (e, t) {
              return console.error(e, t), Promise.resolve();
            },
          }),
        responsesCache: i(),
        requestsCache: i({ serializable: !1 }),
        hostsCache: u({ caches: [a({ key: ''.concat('4.0.0', '-').concat(e) }), i()] }),
        userAgent: q('4.0.0').add({ segment: 'Browser', version: 'lite' }),
        authMode: f.WithinQueryParameters,
      };
    return T(
      r({}, s, {}, n, {
        methods: {
          search: C,
          searchForFacetValues: N,
          multipleQueries: C,
          multipleSearchForFacetValues: N,
          initIndex: function (e) {
            return function (t) {
              return x(e)(t, { methods: { search: k, searchForFacetValues: J } });
            };
          },
        },
      })
    );
  }
  return (R.version = '4.0.0'), R;
});
